<p>scatter-plot-chart-analytics works!</p>
